module.exports = __webpack_public_path__ + "img/jyz.494dd387.png";